import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './_core/guard/auth.guard';
import { ForgotpasswordComponent } from './pages/forgotpassword/forgotpassword.component';
import { LoginComponent } from './pages/login/login.component';
import { ReviewVoicemailComponent } from './pages/review-voicemail/review-voicemail.component';
import { FaxViewerComponent } from './pages/queue/common/case-detail/compose/fax-viewer/fax-viewer.component';
//import { AuthGuard } from './../../_core/guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
    data: { showHeader: false, showFooter: false },
  },
  {
    path: 'sso/callback',
    component: LoginComponent,
    data: { showHeader: false, showFooter: false },
  },
  {
    path: 'SwitchPod',
    component: LoginComponent,
    data: { showHeader: false, showFooter: false },
  },
  {
    path: 'forgot-password',
    component: ForgotpasswordComponent,
    data: { showHeader: false, showFooter: false },
  },
  {
    path: ':companyCode/Performance',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
    data: { showHeader: true, showFooter: false, roles: ['user', 'manager'] },
    canActivate: [AuthGuard],
  },

  {
    path: ':companyCode/Queue',
    loadChildren: () => import('./pages/queue/queue.module').then(m => m.QueueModule),
    data: { showHeader: true, showFooter: false, roles: ['agent', 'manager'] },
    canActivate: [AuthGuard],
  },
  {
    path: ':companyCode/Console',
    loadChildren: () => import('./pages/console/console.module').then(m => m.ConsoleModule),
    data: { showHeader: true, showFooter: false, roles: ['agent', 'manager'] },
    canActivate: [AuthGuard],
  },
  {
    path: ':companyCode/audio',
    component: ReviewVoicemailComponent,
    data: { showHeader: false, showFooter: false, roles: ['agent', 'manager'] },
    canActivate: [AuthGuard],
  },
  {
    path: ':companyCode/file',
    component: FaxViewerComponent,
    data: { showHeader: false, showFooter: false, roles: ['agent', 'manager'] },
    canActivate: [AuthGuard],
  }
  
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {onSameUrlNavigation:'reload'})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
